export const defaultStrings = {
	noResultsFound: 'No results found',
	searching: 'Searching ...',
	noItemsAssigned: 'No items assigned.',
	findItemsPlaceholder: 'Find items ...',
	done: 'Done',
	recordLimit: 'Please revise your search for better results'
};
